import type { App } from 'vue'
import imgLazy from './modules/imgLazy'

const directivesList: any = {
  // Custom directives
  imgLazy
}

const directives = {
  install: (app: App<Element>) => {
    Object.keys(directivesList).forEach((key) => {
      // 注册所有自定义指令
      app.directive(key, directivesList[key])
    })
  }
}

export default directives
